import { Nav, Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { AttachmentPinSymbolSVG } from 'src/Member/img/NotificationSVG';
import './MessageListComponent.scss';
import './../../NotificationPopup.scss';
import { useSelector } from 'react-redux';
import { formatMessageTime } from 'src/common/utils';

function MessageListComponent({
  item,
  onClick,
  itemIndex = 0,
  selectedIndex = 0,
  isNotificationPopupList = false,
}) {
  const { Sender_Email } = useSelector(
    (state) => state?.app?.appConfigs?.Email_Configration,
  );
  const getMessageTypes = (typeValue) => {
    const messageType = typeValue;
    if (messageType === 'Claims') {
      return <span className="claim-class">{messageType}</span>;
    } else if (messageType === 'Authorizations') {
      return <span className="Authorizations-class">{messageType}</span>;
    } else {
      return <span className="enrollment-class">{messageType}</span>;
    }
  };

  const TruncatedHtml = ({ content, maxLength }) => {
    let modifiedContent = '';
    if (content?.startsWith('"') && content?.endsWith('"')) {
      modifiedContent = content?.substring(1, content?.length - 1);
    } else {
      modifiedContent = content;
    }
    const splitedContent = modifiedContent?.split(
      item?.MessageSentReceived === 'S' ? '\n' : '\\n',
    )[0];
    const trimedConent = splitedContent?.replaceAll('&nbsp;', '\u00A0');

    //console.log('trimedConent', trimedConent);
    if (trimedConent?.length <= maxLength || trimedConent === undefined) {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: trimedConent ? trimedConent : '' }}
        />
      );
    }

    const truncatedContent = trimedConent?.substring(0, maxLength) + '...';
    //console.log('truncatedContent', truncatedContent);
    return <div dangerouslySetInnerHTML={{ __html: truncatedContent }} />;
  };

  return (
    <Nav.Item
      className={`${
        item?.isread === false ? 'background-isread' : ''
      } messages-list-margin " `}
      onClick={onClick}
      key={item.id}
      aria-label={`${
        item.attachments === true ? 'Has attachment,' : 'Has no attachment'
      } Subject ${item?.EventTitle}, Message caregory ${
        item?.MessagecategorymasterDTOObj?.Categorydesc
      } Recieved ${formatMessageTime(item.ReceivedDateTime)}`}
      role="tab"
    >
      <Nav.Link className={selectedIndex === itemIndex ? 'active' : null}>
        <Row>
          <div className="pt-2 ml-3 mr-3" aria-hidden={true}>
            <span className="message-user-icon-img">
              {/*{item.FirstName.charAt(0) + item.LastName.charAt(0)} */}
              {Sender_Email.charAt(0)}
            </span>
          </div>
          <Col md={6} className="d-flex flex-column pl-0 pr-0 pt-1">
            {item?.EventTitle?.length > 25 && !isNotificationPopupList ? (
              <OverlayTrigger
                placement="top"
                delay={{ show: 200, hide: 450 }}
                overlay={
                  <Popover>
                    <Popover.Content>
                      <div className="tooltip-header">{item?.EventTitle}</div>
                    </Popover.Content>
                  </Popover>
                }
              >
                <div className="message-title-ellipsis">
                  <TruncatedHtml
                    content={item?.EventTitle?.trim()}
                    maxLength={25}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <div className="message-title">
                {isNotificationPopupList
                  ? item?.EventTitle?.substring(0, 23) +
                    (item?.EventTitle?.length > 23 ? '...' : '')
                  : item?.EventTitle}
              </div>
            )}
            {item?.EventDesc?.length > 30 ? (
              <OverlayTrigger
                placement="top"
                delay={{ show: 200, hide: 450 }}
                overlay={
                  <Popover>
                    <Popover.Content>
                      <div className="tooltip-header">
                        <TruncatedHtml
                          content={item.EventDesc?.trim()}
                          maxLength={item.EventDesc?.length}
                        />
                      </div>
                    </Popover.Content>
                  </Popover>
                }
              >
                <div className="message-subject-ellipsis">
                  <TruncatedHtml
                    content={item.EventDesc?.trim()}
                    maxLength={25}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <div className="message-subject">
                <TruncatedHtml
                  content={item.EventDesc?.trim()}
                  maxLength={30}
                />
              </div>
            )}
          </Col>
          <Col className="text-right pl-0 pt-2 d-flex justify-content-end">
            <span className="pr-1">
              {item.attachments === true ? (
                <AttachmentPinSymbolSVG className="attachmentsymbol-svg" />
              ) : (
                ''
              )}
            </span>
            <div className="d-flex flex-column">
              <span
                className={`message-type-clas mb-1 ${
                  !item.isread && 'unreadMark'
                }`}
              >
                <span className="sr-only">category</span>

                {getMessageTypes(
                  item?.MessagecategorymasterDTOObj?.Categorydesc,
                )}
              </span>{' '}
              <span className="message-received">
                {formatMessageTime(item.ReceivedDateTime)}
              </span>
            </div>
          </Col>
        </Row>
      </Nav.Link>
    </Nav.Item>
  );
}

export default MessageListComponent;
